import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export function Loader({ className, label }) {
  return (
    <div className={cn("flex flex-col items-center justify-center gap-3 py-16 text-brand-mute", className)}>
      <Loader2 className="h-6 w-6 animate-spin text-brand-red" />
      {label && <p className="text-sm">{label}</p>}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-border bg-white/60 px-6 py-16 text-center">
      {Icon && (
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-red/10 text-brand-red">
          <Icon className="h-6 w-6" />
        </div>
      )}
      <h3 className="font-heading text-lg font-bold text-brand-ink">{title}</h3>
      {description && <p className="mt-1 max-w-md text-sm text-brand-mute">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
